import React from 'react'
import {Modal} from "react-bootstrap"


function ModalPolityka(props) {
    return (
      <Modal
        show={props.show}
        onHide={() => props.handleclose()}
        centered
        size="lg"
      >
        <div className="p-xl-4 p-xxl-5">
          <Modal.Header closeButton>
            <Modal.Title>Privacy policy</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <p><strong>Privacy policy and use of cookies on the website orlencharge.pl (hereinafter referred to as Website)</strong></p>
          <p>The owner and the administrator of the service orlencharge.pl is ORLEN S.A.., with
its registered office at ul. Chemików 7, 09-411 Płock, Poland, entered in the
business register of the National Court Register maintained by the District Court for
the Łódź-Śródmieście, 20th Commercial Division of the National Court Register,
under No. KRS 0000028860, Tax Identification (NIP) No. 774-00-01-454, with a
share capital/paid-up capital of PLN 534.636.326,25, email: media@orlen.pl
(hereinafter referred to as ORLEN). On the Website, you can find comprehensive
information about the electric vehicle charging infrastructure offered by the ORLEN
Group. The Website allows you to explore charging station locations, the types of
available chargers, and services supporting electromobility. You will also find
information about current promotions available through ORLEN CHARGE.</p>
          <p>This privacy policy contains the information on the processing of your personal data
that you may provide to us while visiting the website and on the use of cookies on
our website. This privacy policy contains the information on the processing of your
personal data that you may provide to us while visiting the website and on the use
of cookies on our website. Our goal is to protect your personal data on the Internet.
We will make every effort to protect your privacy when you visit the Website. We
observe internationally recognised security standards and our information security
management system is independently certified and compliant with the requirements
of the ISO/IEC 27001 standard. We have implemented framework policies and
procedures and provided training on data protection, confidentiality and security,
and regularly check the measures in place in term of data protection adequacy.</p>

          <h4>Cookies</h4>
          <p><strong>What are cookies?</strong></p>
          <p>In order for the website to work properly, it is sometimes necessary to
place small data files, called cookies, on your device. We provide you with
information on the types of cookies used in the form of a banner (window)
that you can display at any time via <a href="javascript: Cookiebot.renew()" class="cookieRenew">this link</a>.</p>
          <p>For some types of cookies, your consent is required, which you can
change or revoke at any time by setting your preferences in the banner
(window) accessible via <a href="javascript: Cookiebot.renew()" class="cookieRenew">this link</a>.</p>
          <p>If cookie permission is comfort for all types of cookies, your consent will be
valid for 12 months, unless you change it beforehand. If you don't agree,
your consent will be stored for a maximum of 14 days.</p>
          <p>Cookies are used for storing the information which the Website may need
          to:</p>
<ul>
  <li>adapt itself to the way it is used by users,</li>
  <li>collect statistical data, e.g. which pages have been visited, what content is
downloaded, as well as information on the domain name of the Internet
services provider or the visitor’s country of origin.</li>
</ul>

          <h4>Rules of personal data protection</h4>
          <p><strong>How is personal data processed for the purposes of the Website?</strong></p>
          <p>ORLEN SA. has appointed a Data Protection Officer who may be
contacted on all matters regarding personal data processing and exercise
of related rights.
Detailed data of the Data Protection Officer at ORLEN S.A. are available
at www.orlen.pl in the "Contacts" tab. If you want to contact the Data
Protection Officer, please use the following contact details:</p>
        <ul>
          <li>address: address of the registered office of ORLEN with additional
          information “Inspektor Ochrony Danych” (Data Protection Officer)</li>
          <li>e-mail address: daneosobowe@orlen.pl</li>
        </ul>

        <p><strong>What is the purpose of processing your personal data?</strong></p>
        <p>Your personal data will be processed for the purpose of service provision
by ORLEN. Your data may also be processed to tailor the Website’s
content to your interests, detect any instances of improper use, perform
statistical measurements, improve the quality of ORLEN’s services,
answer your queries and and fraud detection. In addition, your data may
be processed with your consent in order to send the requested information
from the Website.</p>

        <p><strong>How long will your personal data be stored?</strong></p>
        <p>As regards ORLEN services, your data will be processed for the period in
which these services are provided and, sometimes, after that period, but
only if permitted or required by applicable laws, e.g. for statistical or
accounting purposes, or to exercise legal claims. In such cases, your data
will be processed as long as necessary for the fulfilment of these purposes
or until you have objected to it or until you have finished using the
services. As for personal data processed with your consent, e.g. in order
to send the ordered information from the Website, these data will be
processed until the consent is withdrawn.</p>

      <p><strong>What is the legal basis for processing your personal data?</strong></p>
      <p>With respect to ORLEN’s services provided in connection with the
Website, your data will be processed in accordance with Article 6(1)(b) of
the GDPR (processing is necessary for the performance of a contract to
which the data subject is party).</p>
      <p>As regards adapting the Website’s content to your ways of using and marketing ORLEN's own products or services, performing statistical measurements, enhancing services, and answering your queries, your data will be processed in accordance with Article 6(1)(f) of the GDPR (processing is necessary for the purposes of the legitimate interests pursued by ORLEN). The legitimate interests pursued by the controller include customising the Website’s content to your needs, ensuring the security of these services, as well as their constant enhancement.</p>
      <p>With regard to sending the ordered information from the Website to personal data provided on the Website, the basis for processing is art. 6 (1)(a) of the GDPR (consent).</p>

      <p><strong>Requirement to provide data</strong></p>
      <p>Providing your personal data is necessary for proper provision of services by ORLEN. If you do not provide such data, it will be impossible for ORLEN to provide its services.</p>
      <p>Processing your data for the other purposes, i.e. to adapt the Website’s content to your interests, perform statistical measurements and enhance services on the Website, is necessary to ensure high service quality. If we do not collect your personal data for these purposes, we may be unable to properly provide our services.</p>

<p><strong>Who will receive your personal data?</strong></p>
<p>Your data may be provided to entities processing personal data for the controller, such as IT services providers and marketing agencies. Such entities process the data under an agreement with the controller and only in accordance with the controller’s instructions.</p>

<p><strong>What are your rights related to the processing of your personal data?</strong></p>
<p>You have the following rights in connection with our processing of your personal data:</p>
<ul>
<li>the right to access your data,</li>
<li>the right to have your data rectified,</li>
<li>the right to have your data erased (in certain situations),</li>
<li>the right to lodge a complaint with the supervisory authority competent for the protection of personal data,</li>
<li>the right to restrict the processing of personal data. If your data is processed on the basis of your consent or as part of a service provided to you (the data is necessary to provide the service), you may also exercise the following rights: </li>
<li>the right to withdraw your consent to the extent it provides the basis for data processing. The withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal.</li>
<li>the right to personal data portability, i.e. the right to receive your personal data from your data controller in a structured, commonly used and machine-readable format. You may provide such data to another data controller.</li>
</ul>

<p>To exercise the above rights, please contact the data controller or the Data Protection Officer. The contact details are presented above.</p>
<p>We inform you may file a complaint with the President of the Personal Data Protection Office.</p>

<h4>Miscellaneous</h4>
<p>The services and functions offered as part of the Website will be expanded over time, which means that in the future ORLEN S.A. may introduce changes to this document. The information on any changes in the Privacy Policy will be published on the Website. Each time a change is made, a new version of the Privacy Policy will be published, with a new date. All important changes will be highlighted. This document is for information purposes only.</p>

          </Modal.Body>
        </div>
      </Modal>
    )
}

export default ModalPolityka
